import { PrivateCustomer } from './private-customer.model';
import { AuthorizeResult, BankIdVerification } from '@core/models/initialize-response.model';
import { InFlightOrder } from '@core/models/in-flight-order.model';
import { salesConstants } from '@sales/constants/sales-constants';
import { CustomerEquipment } from './customer-equipment';
import { CustomerErrorCode } from '@app/sales/constants/ProblemCodes';

export class CustomerStateModel {
  customerId?: string;
  isExistingCustomer: boolean;
  selectedFromCustomerSearch: boolean;
  changeCustomer: string;

  privateCustomer: PrivateCustomer;

  invoiceType?: string;
  consentChecked: boolean;
  hasSecretNumber: boolean;
  authorizeResult: AuthorizeResult;

  bankIdVerification: BankIdVerification;

  isLoadingCustomer: boolean;
  isLoadingProducts: boolean;
  isLoadingCustomerDownPaymentCheck: boolean;
  isLoadingCustomerCreditCheck: boolean;
  isLoadingInFlightOrders: boolean;
  hasPerformedAllowanceCheck: boolean;
  hasPerformedDetailedCreditCheck: boolean;
  customerError: string;
  customerErrorCode?: CustomerErrorCode;

  inFlightOrders: InFlightOrder[];

  customerEquipment: CustomerEquipment[];

  initialCustomerInfo: PrivateCustomer;
  constructor() {
    this.authorizeResult = new AuthorizeResult();
    this.privateCustomer = new PrivateCustomer();
    this.invoiceType = salesConstants.invoiceTypes.paper;
    this.consentChecked = false;
    this.initialCustomerInfo = new PrivateCustomer();
  }
}

export class CustomerResult {
  id: string;
}
